"use client";

import { Modal, ModalContent, ModalBody, useDisclosure, ModalHeader } from "@nextui-org/react";
import { Button, buttonVariants } from "@/03-presenters/components/ui/button";
import Image from "next/image";
import { cn } from "@/lib/utils";
// import { MagicLinkLoginForm, signInWithResend } from "./form/MagicLinkLogin";
import { useFormState } from "react-dom";
// import { GithubLogin } from "./form/GithubLogin";
// import { TikTokLogin } from "./form/TiktokLogin";
import { createContext, useEffect, useState } from "react";
import { useToast } from "@/03-presenters/components/ui/use-toast";
import LoginBody from "./LoginBody";
import { create } from "zustand";
import { cookies } from "next/headers";
import { useRouter } from "next/navigation";
type FormPending = {
  emailPending: boolean;
  githubPending: boolean;
  tiktokPending: boolean;
};
type LoginContext = {
  formPendingState: FormPending;
  setFormPendingState: React.Dispatch<React.SetStateAction<FormPending>>;
  pending: boolean;
};
export const LoginContext = createContext<LoginContext>({
  pending: false,
  formPendingState: {
    emailPending: false,
    githubPending: false,
    tiktokPending: false
  },
  setFormPendingState: () => {}
});
const MagicLinkSuccessComp = () => {
  return <ModalContent className="py-6" data-sentry-element="ModalContent" data-sentry-component="MagicLinkSuccessComp" data-sentry-source-file="index.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">请检查邮件</ModalHeader>
      <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="index.tsx">通过邮件链接点击登录</ModalBody>
    </ModalContent>;
};

// const LoginBody = ({ emailFormAction }: any) => {
//   return (
//     <ModalContent className="py-6">
//       <ModalBody>
//         <div className="flex w-full flex-col items-center justify-center gap-4">
//           <div className="mx-auto flex items-center gap-4">
//             <div className="relative h-8 w-8">
//               <Image
//                 src="/aisale1.svg"
//                 fill
//                 className="object-contain"
//                 alt="logo"
//               />
//             </div>
//             <div className="font-medium">登录/注册账号</div>
//           </div>
//           <MagicLinkLoginForm formAction={emailFormAction} />
//           <div>或</div>
//           <div className="flex w-full justify-center gap-4">
//             <GithubLogin />
//             <TikTokLogin />
//           </div>
//         </div>
//       </ModalBody>
//     </ModalContent>
//   );
// };

type LoginBtnStore = {
  isOpen: boolean;
  onOpen: () => void;
  setOnOpen: (f: () => void) => void;
  setIsOpen: (f: boolean) => void;
};
export const useLoginBtnStore = create<LoginBtnStore>(set => ({
  isOpen: false,
  setIsOpen: f => set(() => ({
    isOpen: f
  })),
  onOpen: () => {},
  setOnOpen: f => set(() => ({
    onOpen: f
  }))
}));
export default function Login({
  className
}: {
  className?: string;
}) {
  const router = useRouter();
  const {
    isOpen,
    onOpen,
    onOpenChange
  } = useDisclosure();
  const setOnOpen = useLoginBtnStore(s => s.setOnOpen);
  const setIsOpen = useLoginBtnStore(s => s.setIsOpen);
  useEffect(() => {
    setOnOpen(onOpen);
  }, [onOpen, setOnOpen]);
  useEffect(() => {
    setIsOpen(isOpen);
  }, [setIsOpen, isOpen]);
  return <>
      <Button
    // onClick={() => onOpen()}
    onClick={() => {
      localStorage.setItem("redirect_url", window.location.pathname + window.location.search);
      router.push("/login");
    }} className={cn(buttonVariants(), "search-btn", className)} data-sentry-element="Button" data-sentry-source-file="index.tsx">
        注册/登录
      </Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="lg" isDismissable={false} data-sentry-element="Modal" data-sentry-source-file="index.tsx">
        <LoginBody data-sentry-element="LoginBody" data-sentry-source-file="index.tsx" />
        {/* {showSuccess ? <MagicLinkSuccessComp /> : <LoginBody />} */}
      </Modal>
    </>;
}
/* <LoginInBody emailFormAction={magicLinkFormAction} /> */